import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { OnboardingPage } from "@/components/pages/onboarding";

/** First-run profile + onboarding wizard; persists `workspace_persona`, school, and optional `onboarding` json. */
export const UserProfilePage = () => {
  const { userData } = useAuth();

  if (userData) {
    return <Navigate to="/" />;
  }

  return <OnboardingPage />;
};
